<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import { page } from '$app/state';
	import dave404 from '$routes/(public)/images/404-Dave.svg';
	import insertCorner from '$routes/(public)/images/insert-A-w-shadow-cropped.png';
	const message =
		page.error?.message ?? "Sorry, we can't find the page you're looking for.";
</script>

<Section
	backgroundColor="blue"
	class="from-indow-blue bg-gradient-to-b to-white pt-0"
>
	<Image src={insertCorner} />

	<h1>{message}</h1>

	<p class="!text-indow-grey-dark max-w-md text-xl">
		But we can help you find comfort, quiet, and energy savings for your home or
		business!
	</p>

	<Button href="/about-indow/contact">CONTACT US TODAY</Button>

	<Image src={dave404} class="px-4" alt="404-Dave Image" />
</Section>
